module.exports = __webpack_public_path__ + "static/media/apple_iphone_plus.bee0c608.jpg";